import React from "react";

import { css, cx } from "@emotion/css";
import { useFormContext } from "react-hook-form";

import { FontSizes } from "@/assets/fonts.ts";
import { Icons } from "@/assets/icons.ts";
import { useStyles } from "@/hooks/useStyles.ts";
import { Theme } from "@/theme/CreateTheme.ts";
import { Button } from "@/uiKit/atoms/Button.tsx";

export type MessageBoxSendButtonProps = {
  className?: string;
};

export const MessageBoxSendButton: React.FC<MessageBoxSendButtonProps> = ({ className }) => {
  const styles = useStyles(makeStyles);
  const { formState } = useFormContext();
  const sendDisabled = formState.disabled || formState.isSubmitting;

  return (
    <div className={cx(styles.container, className)}>
      <Button
        variant="contained"
        data-action="messaging.message.send"
        className={styles.sendButton}
        startIcon={<Icons.sendMessage className={styles.icon} />}
        type="submit"
        disabled={sendDisabled}
      />
    </div>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css({
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
  }),
  sendButton: css({
    borderRadius: theme.spacing(12),
    padding: theme.spacing(4),
    aspectRatio: "1",
    "& .MuiButton-startIcon": {
      lineHeight: 0,
    },
  }),
  icon: css({
    width: FontSizes.bodyLarge,
    height: FontSizes.bodyLarge,
  }),
  disabledSendButtonIcon: css({
    color: theme.palette.action.disabled,
  }),
  disabledSendButton: css({
    backgroundColor: theme.palette.action.disabledBackground,
    borderColor: theme.palette.common.white,
  }),
});
